import { auth } from '../firebase';
import { markExpensesCacheDirty } from './expensesCache';

export class IncomingApiError extends Error {
  constructor(message, { code = 'INCOMING_FAILED', status = 0, uncertain = false, data = null } = {}) {
    super(message);
    this.name = 'IncomingApiError';
    this.code = code;
    this.status = status;
    this.uncertain = uncertain;
    this.data = data;
  }
}

const parseApiJson = async (res) => {
  const text = await res.text();
  try { return text ? JSON.parse(text) : {}; }
  catch (_error) { return { error: text || 'Respuesta inválida del servidor' }; }
};

export const createIncomingOperationKey = () => {
  try {
    if (globalThis.crypto?.randomUUID) return globalThis.crypto.randomUUID().replace(/-/g, '_');
  } catch (_error) {}
  return `incoming_${Date.now()}_${Math.random().toString(36).slice(2)}_${Math.random().toString(36).slice(2)}`;
};

async function postIncoming(payload, idempotencyKey) {
  if (!idempotencyKey) {
    throw new IncomingApiError('No se pudo preparar una operación segura de entradas.', {
      code: 'INCOMING_IDEMPOTENCY_REQUIRED',
    });
  }

  const token = await auth.currentUser?.getIdToken();
  if (!token) {
    throw new IncomingApiError('No se pudo obtener la sesión. Vuelve a iniciar sesión.', {
      code: 'AUTH_REQUIRED',
    });
  }

  let res;
  try {
    res = await fetch('/api/incoming/process', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
        'X-Idempotency-Key': idempotencyKey,
      },
      body: JSON.stringify(payload),
    });
  } catch (_error) {
    throw new IncomingApiError(
      'No se pudo confirmar si la operación de entradas quedó registrada. Reintenta la misma operación antes de volver a crearla.',
      { code: 'INCOMING_NETWORK_UNCERTAIN', uncertain: true }
    );
  }

  const data = await parseApiJson(res);
  if (!res.ok) {
    throw new IncomingApiError(data?.error || 'No se pudo completar la operación de entradas', {
      code: data?.code || 'INCOMING_FAILED',
      status: res.status,
      uncertain: data?.code === 'INCOMING_PROCESSING',
      data,
    });
  }
  markExpensesCacheDirty('incoming-operation-completed');
  return data;
}

export const createIncomingEntryApi = ({ entry, newProducts = [], idempotencyKey }) =>
  postIncoming({ action: 'create', entry, newProducts }, idempotencyKey);

export const updateIncomingEntryApi = ({ entryId, entry, idempotencyKey }) =>
  postIncoming({ action: 'update', entryId, entry }, idempotencyKey);

export const deleteIncomingEntryApi = ({ entryId, idempotencyKey }) =>
  postIncoming({ action: 'delete', entryId }, idempotencyKey);

export const setIncomingPaymentStatusApi = ({ entryId, paymentStatus, idempotencyKey }) =>
  postIncoming({ action: 'setPaymentStatus', entryId, paymentStatus }, idempotencyKey);
